import { render, staticRenderFns } from "./MagazineDetail.vue?vue&type=template&id=6dca73a2&scoped=true"
import script from "./MagazineDetail.vue?vue&type=script&lang=js"
export * from "./MagazineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca73a2",
  null
  
)

export default component.exports